import { Divider } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import * as FileSaver from 'file-saver'
import * as JSZip from 'jszip'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import React from 'react'
import FileReaderVisible from '../../../../../components/Uploader/FileReaderVisible'

const DownloadDrawer = ({
  isDownloadDrawerVisible,
  setIsDownloadDrawerVisible,
  docDetails,
}) => {
  const documentsUrls = docDetails?.map(item => {
    return item.doc.url
  })
  const student = documentsUrls?.filter(document => document !== undefined)
  const downloadAsZip = () => {
    const zip = new JSZip()

    student?.forEach((url, index) => {
      const filename = `document_${index + 1}.pdf` // You can customize the filename here
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          zip.file(filename, blob)
          if (index === student?.length - 1) {
            zip.generateAsync({ type: 'blob' }).then(content => {
              FileSaver.saveAs(content, 'documents.zip')
            })
          }
        })
        .catch(error => {
          console.error('Error downloading document:', error)
        })
    })
  }

  const handleSubmit = async () => {
    downloadAsZip()
    setIsDownloadDrawerVisible(false)
  }
  const onClose = () => {
    setIsDownloadDrawerVisible(false)
  }

  const content = () => {
    return (
      <div>
        <div>
          <div
            style={{
              fontWeight: '700',
              fontSize: '18px',
              color: ' #4D566E',
              marginBottom: '40px',
            }}
          >
            Documents
          </div>
          <div>
            {docDetails?.map((item, index) => (
              <div key={index + item?.document?.document_name}>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#4D566E',
                  }}
                >
                  {item?.document?.document_name}
                </div>
                <FileReaderVisible
                  doc={item.doc}
                  DocumentsDetails={docDetails}
                />
                <Divider />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary height="38px" text="Cancel" onClick={onClose} />
        <Button.Secondary
          height="38px"
          text="Download All"
          htmlType="submit"
          onClick={handleSubmit}
          style={{ background: 'rgb(50, 73, 215)', color: 'white' }}
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="43%"
      title={'Uploaded Documents'}
      placement="right"
      visible={isDownloadDrawerVisible}
      content={content()}
      footer={footer()}
      onClose={onClose}
      closable
    />
  )
}

export default DownloadDrawer
